
import React from 'react'
import introLogo from "./asset/intrologo.svg"
import project4img from "./asset/project_4.png"
import project6img from "./asset/Project_6.jpg"
import project7img from "./asset/Project_7.jpg"
import project8img from "./asset/project_8.JPG"
import project9img from "./asset/project_9.png"
import cyclisticBikeLogo from "./asset/cyclistic_bike_share_logo.png"
import uniImg from "./asset/uni_img.png"
import microsoftImg from "./asset/microsoft_img.png"
import google_img from "./asset/google_img.webp"
import freecodecamp from "./asset/freecodecamp.png"
import { IconContext } from "react-icons"
import {MdOutlineMail} from "react-icons/md"
import {AiFillGithub, AiFillLinkedin} from "react-icons/ai"







function Home() {
    

  return (
    <body className= 'bg-gradient-to-r from-[#ecf2fd] to-[#cfdef3] font-["Raleway"] text-[14px] '>

                <nav className='nav_bar flex justify-between' id="nav_bar"> 
                    <a href='#home' className='pl-4 transition duration-300 ease-in-out nav_rs flex font-["Cedarville_Cursive"] text-[20px] font-bold text-gray-700 w-[20%]'> 
                        Imsan 
                    </a>
                    
                </nav>
            
            <section className='flex flex-col items-center justify-center h-screen ' id='home'>

                <div className='intro_container w-full flex flex-col justify-center items-center'>
                    <img className='w-48' src={introLogo} alt='Ibrahim Mohamed Portfolio Website' />
                    <h1 className='intro_2 text-2xl sm:text-4xl mt-6'> <span className='font-bold'> Ibrahim </span> <span className='font-bold text-transparent bg-clip-text bg-gradient-to-br from-purple-500 to-blue-400'>Mohamed</span></h1>
                    <p className="text-md text-gray-700 mt-2">A Frontend Developer</p>
                    <div className="pt-4 sm:w-9/12 lg:w-7/12 justify-center pl-2 pr-2 p-2 mt-4 text-justify text-gray-900">
                    <p >I'm a certified <strong className="text-black">Frontend Web Developer, Data Analyst, and an Electronics Engineer. </strong> This is my portfolio website. All the <strong className="text-black">projects</strong> I have done will be displayed here. </p>
                    </div>
                    <br></br>
                    <p className='intro_4'></p>
                    <br></br>

                    <div className=" flex w-fit gap-4 items-center">
                    
                        <a  href='mailto: imsanwork@gmail.com'>
                        
                            <div className=' w-fit p-2 pl-6 pr-6 rounded-md transition ease-in-out delay-75 bg-teal-200 hover:bg-teal-900 hover:text-white'>
                            <IconContext.Provider value={{ size: "20px" }}>
                                <MdOutlineMail
                                />
                            </IconContext.Provider>
                            </div>
                            
                        </a>

                        <a href='https://github.com/ibra-san' target='_blank' rel="noreferrer">
                            <div className=' w-fit p-2 pl-6 pr-6 rounded-md transition ease-in-out delay-75 bg-violet-200 hover:bg-violet-600 hover:text-white'>
                                <IconContext.Provider value={{ size: "20px" }}>
                                    <AiFillGithub />
                                    
                                </IconContext.Provider>
                            </div>
                        </a>

                        <a href='https://www.linkedin.com/in/ibrasan' target='_blank' rel="noreferrer">
                            <div className=' w-fit p-2 pl-6 pr-6 rounded-md transition ease-in-out delay-75 bg-blue-200 hover:bg-blue-900 hover:text-white'>
                                <IconContext.Provider value={{ size: "20px" }}>
                                    <AiFillLinkedin
                                    />
                                </IconContext.Provider>
                            </div>
                        </a>
                     
                        

                    </div>
                </div>
                

            </section>
            
            
            
            <section id='projects_web_dev' className='projects pt-12 pb-8 '>
                <p className='mb-12 ml-10 font-bold w-fit p-2 text-lg'> Projects - Web Development </p>

                <div id='projects_container' className='flex flex-wrap gap-8 justify-center'>

                {/* Begining of ID project Code*/ }
                <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='10'>
                        
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Employee NFC ID Card Design </h2>
                            <p className='p-1 pl-2'> A landing page for our employee's NFC ID Card Design.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-blue-500 to-blue-200 shadow-lg shadow-blue-500/50 rounded-full p-1 pl-2 pr-2 '>HTML</p>
                                <p className='font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full p-1 pl-2 pr-2'>CSS</p>
                
                            </div>
                        </div>

                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="projects\ID cards\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-4 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                        </div>
                        
                    </div>
                {/* End of ID project Code*/ }
                <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='8'>
                        <img alt='Dad joke generator application' className='rounded-xl' src={project9img}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Sushi San Restaurant</h2>
                            <p className='p-1 pl-2'> A landing page for Sushi San Restaurant located in Japan.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-blue-500 to-blue-200 shadow-lg shadow-blue-500/50 rounded-full p-1 pl-2 pr-2 '>HTML</p>
                                <p className='font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full p-1 pl-2 pr-2'>TailwindCSS</p>
                                <p className='font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full p-1 pl-2 pr-2'>CSS</p>
                                <p className='font-bold bg-gradient-to-br from-orange-500 to-orange-200 shadow-lg shadow-orange-500/50 rounded-full p-1 pl-2 pr-2'>JS</p>
                            </div>
                        </div>

                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="projects\project_9\src\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                            <a href="https://github.com/ibra-san/sushi-san" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-black hover:text-white' >Source Code</a>
                        </div>
                        
                    </div>
             
                    <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='8'>
                        <img alt='Dad joke generator application' className='rounded-xl' src={project8img}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Dad joke generator</h2>
                            <p className='p-1 pl-2'> A fun project to make you laugh: generate as many dad jokes as you can until your heart is content.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-blue-500 to-blue-200 shadow-lg shadow-blue-500/50 rounded-full p-1 pl-2 pr-2 '>HTML</p>
                                <p className='font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full p-1 pl-2 pr-2'>CSS</p>
                                <p className='font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full p-1 pl-2 pr-2'>JS</p>
                                <p className='font-bold bg-gradient-to-br from-orange-500 to-orange-200 shadow-lg shadow-orange-500/50 rounded-full p-1 pl-2 pr-2'>NodeJS</p>
                                <p className='font-bold bg-gradient-to-br from-teal-500 to-teal-200 shadow-lg shadow-teal-500/50 rounded-full p-1 pl-2 pr-2'>Express</p>
                                <p className='font-bold bg-gradient-to-br from-pink-500 to-pink-200 shadow-lg shadow-pink-500/50 rounded-full p-1 pl-2 pr-2'>API</p>
                                <p className='font-bold bg-gradient-to-br from-purple-500 to-purple-200 shadow-lg shadow-purple-500/50 rounded-full p-1 pl-2 pr-2'>Render</p>
                                <p className='font-bold bg-gradient-to-br from-green-500 to-green-200 shadow-lg shadow-green-500/50 rounded-full p-1 pl-2 pr-2'>Netlify</p>


                            </div>
                        </div>

                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="projects\project_8\frontend\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                            <a href="https://github.com/ibra-san/dad-joke-generator" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-black hover:text-white' >Source Code</a>
                        </div>
                        
                    </div>
                    

                    <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='7'>
                        <img alt='Advance generator app screenshot' className='rounded-xl' src={project7img}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Advice generator app</h2>
                            <p className='p-1 pl-2'> With a press of a button, you can have advice generated just for you.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full p-1 pl-2 pr-2 '>ReactJS</p>
                                <p className='font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full p-1 pl-2 pr-2'>Tailwindcss</p>
                                <p className='font-bold bg-gradient-to-br from-orange-500 to-orange-200 shadow-lg shadow-orange-500/50 rounded-full p-1 pl-2 pr-2'>API</p>
                                <p className='font-bold bg-gradient-to-br from-blue-500 to-blue-200 shadow-lg shadow-blue-500/50 rounded-full p-1 pl-2 pr-2'>Axios</p>



                            </div>
                        </div>
                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="projects\project_7\advice generator app\build\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                            <a href="https://github.com/ibra-san/advice-generator-app-main" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-black hover:text-white' >Source Code</a>
                        </div>
                    </div>




                <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='6'>
                        <img alt='Sunnyside agency landing page screenshot' className='rounded-xl' src={project6img}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Sunnyside Agency Landing Page</h2>
                            <p className='p-1 pl-2'> A landing page for Sunnyside Agency.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-teal-500 to-teal-200 shadow-lg shadow-teal-500/50 rounded-full p-1 pl-2 pr-2 '>ReactJS</p>
                                <p className='font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full p-1 pl-2 pr-2'>SCSS</p>

                            </div>
                        </div>
                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="public\projects\project_6\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                            <a href="https://github.com/ibra-san/sunnyside-agency-landing-page-main" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-black hover:text-white' >Source Code</a>
                        </div>
                    </div>



                <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='5'>
                        <img alt='Snap landing page screenshot' id='img_project_1' className='rounded-xl' src={project4img}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Snap Landing Page</h2>
                            <p className='p-1 pl-2'> A landing page for Snap, a website for remote working opportunities.</p>
                            <div className='project_skills flex flex-row flex-wrap gap-4 pl-2 mt-2 mb-2 '>
                                <p className='font-bold bg-gradient-to-br from-orange-500 to-orange-200 shadow-lg shadow-orange-500/50 rounded-full p-1 pl-2 pr-2 '>HTML</p>
                                <p className='font-bold bg-gradient-to-br from-pink-500 to-pink-200 shadow-lg shadow-pink-500/50 rounded-full p-1 pl-2 pr-2'>SCSS</p>
                                <p className='font-bold bg-gradient-to-br from-violet-500 to-violet-200 shadow-lg shadow-violet-500/50 rounded-full p-1 pl-2 pr-2'>JS</p>

                            </div>
                        </div>
                        <div className='links_container flex flex-col w-[100%] items-center justify-center mt-2' >
                            <a href="public\projects\project_4\index.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >Live Preview</a>
                            <a href="https://github.com/ibra-san/intro-section-with-dropdown-navigation" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-black hover:text-white' >Source Code</a>
                        </div>
                    </div>


                

                

                </div>
            </section>

            <section id='projects_data_analysis' className='projects mt-12 mb-8  '>
                <p className='mb-12 font-bold ml-10 text-lg'> Projects - Data Analysis </p>

                <div id='projects_container_da' className='flex flex-wrap gap-8 justify-center'>


                    <div className='project_card transition ease-in-out delay-75 rounded-xl w-[250px] flex flex-col items-center hover:shadow-2xl duration-300 bg-zinc-100 h-fit' id='7'>
                        <img alt='Data Analysis Case Study - Cyclistic' className='rounded-xl' src={cyclisticBikeLogo}  />
                        <div className='project_information p-1'>
                            <h2 className='p-1 pl-2 font-bold'>Case Study 1 - Cyclistic</h2>
                            <p className='p-1 pl-2'> Cyclistic is a bike-sharing company. The analysis performed will help the marketing team convince casual Cyclistic users to become annual members. </p>
                        </div>
                        <div className='project_skills flex flex-row justify-start w-full gap-4 pl-2 mt-2 mb-2'>
                                <p className='font-bold bg-gradient-to-br from-teal-500 to-teal-200 shadow-lg shadow-teal-500/50 rounded-full p-1 pl-2 pr-2 '>EXCEL</p>
                                <p className='font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full p-1 pl-2 pr-2'>R</p>
                                <p className='font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full p-1 pl-2 pr-2'>RSTUDIO</p>

                            </div>
                        <a href="projects\da_1\da_1.html" target="_blank" rel="noreferrer" className='transition ease-in-out delay-75 w-[90%] p-1 text-center mt-2 mb-6 rounded-full bg-blue-100 hover:bg-blue-600 hover:text-white' >View Report</a>
                    </div>

                </div>
            </section>

            

            <br></br>
            <section className='skill_section flex flex-col mt-12 mb-12'>
                <p className='w-[10%] font-bold mb-8 ml-10 text-lg'> Skills </p>
                <div className='skills_container w-[100%] flex justify-center flex-wrap items-center gap-2 pl-10 pr-10 pt-5 pb-5 '>
                    
                    <div className='skills font-bold bg-gradient-to-br from-blue-500 to-blue-200 shadow-lg shadow-blue-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='html'>HTML</div>
                    <div className='skills font-bold bg-gradient-to-br from-orange-500 to-orange-200 shadow-lg shadow-orange-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='css'>CSS</div>
                    <div className='skills font-bold bg-gradient-to-br from-cyan-500 to-cyan-200 shadow-lg shadow-cyan-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='tailwindcss'>TailWindCSS</div>
                    <div className='skills font-bold bg-gradient-to-br from-red-500 to-red-200 shadow-lg shadow-red-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='scss'>SCSS</div>
                    <div className='skills font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='js'>Javascript</div>
                    <div className='skills font-bold bg-gradient-to-br from-violet-500 to-violet-200 shadow-lg shadow-violet-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='reactjs'>React JS</div>
                    <div className='skills font-bold bg-gradient-to-br from-sky-500 to-sky-200 shadow-lg shadow-sky-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='axios'>Axios</div>
                    <div className='skills font-bold bg-gradient-to-br from-teal-500 to-teal-200 shadow-lg shadow-teal-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='c++'>Object Oriented C++</div>
                    <div className='skills font-bold bg-gradient-to-br from-pink-500 to-pink-200 shadow-lg shadow-pink-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='git'>Git</div>
                    <div className='skills font-bold bg-gradient-to-br from-cyan-500 to-blue-200 shadow-lg shadow-cyan-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='github'>Github</div>
                    <div className='skills font-bold bg-gradient-to-br from-orange-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='netlify'>Netlify</div>
                    <div className='skills font-bold bg-gradient-to-br from-red-500 to-pink-200 shadow-lg shadow-pink-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='api'>REST API</div>
                    <div className='skills font-bold bg-gradient-to-br from-teal-500 to-teal-200 shadow-lg shadow-teal-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='figma'>Figma</div>
                    <div className='skills font-bold bg-gradient-to-br from-slate-500 to-slate-200 shadow-lg shadow-slate-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='sql'>SQL</div>
                    <div className='skills font-bold bg-gradient-to-br from-green-500 to-green-200 shadow-lg shadow-green-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='python'>Python</div>
                    <div className='skills font-bold bg-gradient-to-br from-sky-500 to-white shadow-lg shadow-blue-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='r'>R</div>
                    <div className='skills font-bold bg-gradient-to-br from-yellow-500 to-yellow-200 shadow-lg shadow-yellow-500/50 rounded-full w-fit pl-4 pr-4 p-1' id='rstudio'>RStudio</div>
                </div>
                
            </section>
            <br></br>

            

            <section className='flex flex-col'>
                <p className='font-bold mb-8 ml-10 text-lg'> Achievements </p>

                <div className='flex justify-center gap-8 flex-wrap mb-8'>
                    
                    
                    
                    <div className='w-[250px] rounded-lg bg-zinc-100 p-5 flex flex-col gap-5'>
                        <img src={google_img} alt="Google logo for google analytics certificate" className='achievement_image w-[250px]' />
                        <p className='achievement_information'> Certified Google Data Analytics Professional - June 2023</p>
                    </div>
                    
                    <div className='w-[250px] rounded-lg bg-zinc-100 p-5 flex flex-col gap-5'>
                        <img src={microsoftImg} alt='Microsoft logo for Python Ceritficate' className='achievement_image w-[250px]' />
                        <p className='achievement_information'> Certified Microsoft Professional in Programming using Python. - March 2022</p>
                    </div>

                    <div className='w-[250px] rounded-lg bg-zinc-100 p-5 flex flex-col gap-5'>
                        <img src={freecodecamp} alt='freecodecamp logo for web development certificate' className='achievement_image w-[250px]' />
                        <p className='achievement_information'> Certified in Responsive Web Design & Javascript Algorithms and Data Structures. - November 2021</p>
                    </div>

                    <div className='w-[250px] rounded-lg bg-zinc-100 p-5 flex flex-col gap-5'>
                        <img src={uniImg} alt='Multimedia University logo for my computer engineering certificate'  className='achievement_image w-[250px]' />
                        <p className='achievement_information'> Graduated with a honours, with a Bachelors degree in Electronics majoring in Computer Engineering. - May 2019</p>
                    </div>

                </div>
               
            </section>


        <footer className='bg-neutral-700'> 
                <div className='flex gap-2 justify-end p-4 text-neutral-100 '> &copy; <p className='font-["Cedarville_Cursive"] font-bold text-xl'>Imsan </p> </div>
        </footer>
    </body>
  )
}

export default Home
